document.addEventListener('DOMContentLoaded', function () {
  /* =========================
    DAY / NIGHT 切り替え
  ========================== */
  var sceneItems = document.querySelectorAll('.scene-item');

  sceneItems.forEach(function (item) {
    var checkbox = item.querySelector('.day-night-switch__checkbox');
    var media = item.querySelector('.js-scene-media');
    var inner = item.querySelector('.day-night-switch__inner'); // ← テキスト＆サークルのラッパー

    // スイッチ or メディアがなければスキップ
    if (!checkbox || !media) return;

    var type = media.dataset.mediaType || 'image'; // "image" or "video"
    var daySrc = media.dataset.daySrc || media.getAttribute('src') || ''; // DAY 用 src
    var nightSrc = media.dataset.nightSrc || ''; // NIGHT 用 src

    // NIGHT 側が無ければ切り替え不要
    if (!nightSrc) return;

    // ▼ メディア切り替え処理
    function updateMedia() {
      // ✅ 初期はチェック OFF = DAY、チェック ON = NIGHT
      var isDay = !checkbox.checked; // OFF → true(DAY), ON → false(NIGHT)
      var target = isDay ? daySrc : nightSrc;

      if (type === 'image') {
        media.src = target;
      } else if (type === 'video') {
        var source = media.querySelector('source') || media;

        if (source.src !== target) {
          source.src = target;
          try {
            media.load();
            // autoplay 指定があれば再生
            if (media.autoplay || media.getAttribute('autoplay') !== null) {
              media.play().catch(function () {});
            }
          } catch (e) {
            console.warn(e);
          }
        }
      }
    }

    // ▼ スイッチ変更時：メディア切り替え＋テキストアニメーション用クラス付け替え
    checkbox.addEventListener('change', function () {
      // 1) 先に画像／動画を DAY / NIGHT 切り替え
      updateMedia();

      // 2) スイッチ見た目用のクラス制御（.day-night-switch__inner に対して）
      if (!inner) return;

      inner.classList.remove('is-sliding-end');
      inner.classList.add('is-sliding');

      setTimeout(function () {
        inner.classList.remove('is-sliding');
        inner.classList.add('is-sliding-end');
      }, 250); // サムの移動時間と合わせる
    });

    // ▼ 初期表示（DAY）の状態を反映
    updateMedia();
  });

  /* =========================
    詳細ページ：アンカー位置補正＋レイアウトシフト対策
  ========================== */
  var contents = document.querySelector('.scene-contents');
  if (!contents) return;

  // ▼ 固定ヘッダーの高さを取得（クラス名はテーマに合わせて変更）
  function getHeaderOffset() {
    // SP（〜749px）はヘッダー分のオフセットなし
    if (window.innerWidth <= 749) {
      return 0;
    }
    var header = document.querySelector('header.theme__header');
    return header ? header.offsetHeight : 0;
  }

  // ▼ 現在のハッシュ (#item-3 / #scene-2 など) にスクロール位置を揃える
  function scrollToCurrentHash() {
    var hash = window.location.hash;
    if (!hash) return;

    var target = document.querySelector(hash);
    if (!target) return;

    // レイアウト確定後の位置をベースにスクロール
    var offset = getHeaderOffset();
    var rect = target.getBoundingClientRect();
    var y = rect.top + window.pageYOffset - offset;

    window.scrollTo({
      top: y,
      behavior: 'auto', // アニメーションなしの方がズレにくい
    });
  }

  // ▼ 画像・動画の読み込み完了を待ってから表示＆アンカー補正
  var mediaEls = contents.querySelectorAll('.scene-media');

  if (mediaEls.length === 0) {
    // メディアがない場合はそのまま表示＋スクロール
    contents.classList.add('is-ready');
    scrollToCurrentHash();
    return;
  }

  var loaded = 0;

  function onLoaded() {
    loaded++;
    if (loaded === mediaEls.length) {
      // 全メディアのロード完了＝最終レイアウト
      contents.classList.add('is-ready');

      // レイアウト反映後にアンカー位置へスクロール
      requestAnimationFrame(function () {
        scrollToCurrentHash();
      });
    }
  }

  mediaEls.forEach(function (el) {
    var tag = el.tagName.toLowerCase();

    if (tag === 'img') {
      if (el.complete) {
        onLoaded();
      } else {
        el.addEventListener('load', onLoaded);
        el.addEventListener('error', onLoaded);
      }
    } else if (tag === 'video') {
      // 動画は loadedmetadata でだいたいサイズが確定
      if (el.readyState >= 1) {
        onLoaded();
      } else {
        el.addEventListener('loadedmetadata', onLoaded);
        el.addEventListener('error', onLoaded);
      }
    } else {
      onLoaded();
    }
  });
});

document.addEventListener('click', function (e) {
  const a = e.target.closest('a.js-scene-anchor');
  if (!a) return;

  const hash = a.getAttribute('href');
  if (!hash || hash === '#') return;

  const target = document.querySelector(hash);
  if (!target) return;

  // ブラウザ標準のアンカー移動を止める
  e.preventDefault();
  history.pushState(null, '', hash);

  requestAnimationFrame(function () {
    let offset = 0;

    // PCのみヘッダー分を引く（SPは0）
    if (window.innerWidth > 749) {
      const header = document.querySelector('header.theme__header');
      if (header) offset = header.offsetHeight;
    }

    const rect = target.getBoundingClientRect();
    const y = rect.top + window.pageYOffset - offset;

    window.scrollTo({
      top: y,
      behavior: 'auto', // ← SPズレ防止のため必ず auto
    });
  });
});

// カテゴリをパンくずに反映
(() => {
  // scene 記事じゃなければ何もしない
  const breTitle = document.querySelector('.bre-title--scene');
  if (!breTitle) return;

  // 記事側のカテゴリ（タグから生成している表示）を取得
  const sceneTagEl = document.querySelector('.scene-tag span');
  const categoryText = sceneTagEl?.textContent?.trim();

  if (!categoryText) return;

  // 転記（必要なら aタグ化などもここで可能）
  breTitle.textContent = categoryText;
})();
